export interface CmsMedia {
  data: {
    attributes: {
      url: string
      previewUrl: string
    }
  }
}

export enum TutorialStepActionTypes {
  TutorialStepActionLink = 'ComponentActionActionLink',
  TutorialStepActionVideo = 'ComponentActionActionVideo',
  TutorialStepPlatformLink = 'ComponentActionPlatformLink',
}

// Mapped to the `kind` enum on the CMS tutorial-group content type.
// Using `kind` instead of numeric `id` makes this code dual-compatible with
// Strapi v4 (today) and v5 (where GraphQL stops exposing numeric ids).
export enum TutorialGroups {
  LingoThirdParty = 'lingo_third_party',
  Dexcom = 'dexcom',
  MyFitnessPal = 'my_fitness_pal',
}

export enum TutorialTypes {
  List = 'list',
  Carousel = 'carousel',
}

export enum TutorialSensorKind {
  LingoThirdParty = 'lingo_third_party',
  DexcomG6 = 'dexcom_g6',
  DexcomG6Realtime = 'dexcom_g6_realtime',
  DexcomG7 = 'dexcom_g7',
  DexcomG7Realtime = 'dexcom_g7_realtime',
  DexcomStelo = 'dexcom_stelo',
  DexcomSteloRealtime = 'dexcom_stelo_realtime',
  Libre123IndirectSyncing = 'libre123_indirect_syncing',
}

export enum TutorialPlatform {
  IOS = 'ios',
  Android = 'android',
}

export interface TutorialPreview {
  id: string
  position: string
  name: string
  title: string
  duration: string
  description: string
  buttonText: string
  image?: CmsMedia
  platform: TutorialPlatform | null
  sensorKind: TutorialSensorKind
}
export interface TutorialGroup {
  kind: TutorialGroups
  title: string
  duration: string
  summary: string
  tutorials: TutorialPreview[]
}

export interface TutorialStepActionLink {
  __typename: TutorialStepActionTypes.TutorialStepActionLink
  id: string
  url: string
}
export interface TutorialStepActionVideo {
  __typename: TutorialStepActionTypes.TutorialStepActionVideo
  id: string
  description: string
  title: string
  video?: CmsMedia
}

export interface TutorialStepPlatformLink {
  __typename: TutorialStepActionTypes.TutorialStepPlatformLink
  id: string
  android: {
    url: string
  }
  ios: {
    url: string
  }
}
export interface TutorialStep {
  title: string
  description: string
  duration: string
  buttonText: string
  position: string
  image?: CmsMedia
  warning: string | null
  action: (TutorialStepActionLink | TutorialStepActionVideo | TutorialStepPlatformLink)[]
}

export interface Tutorial {
  id: string
  position: string
  name: string
  title: string
  duration: string
  description: string
  buttonText: string
  image?: CmsMedia
  tutorialType: TutorialTypes
  tutorialSteps: TutorialStep[]
  platform: TutorialPlatform | null
  sensorKind: TutorialSensorKind
  tutorialGroupKind?: TutorialGroups
  tutorialGroupTitle?: string
  tutorialGroupDuration?: string
  tutorialGroupSummary?: string
}

export interface TutorialsStoreState {
  groups: TutorialGroup[]
  tutorials: Tutorial[]
  currentTutorial: Tutorial
  lastFetchedAt: number | null
}

export interface TutorialGroupResponse {
  id: string
  attributes: {
    title: string
    duration: string
    summary: string
    tutorials: { data: TutorialPreviewResponse[] }
  }
}

interface TutorialPreviewResponse {
  id: string
  attributes: {
    position: string
    name: string
    title: string
    duration: string
    description: string
    buttonText: string
    image: CmsMedia
    platform: TutorialPlatform
    sensorKind: TutorialSensorKind
  }
}

interface TutorialStepResponse {
  id: string
  attributes: {
    title: string
    description: string
    duration: string
    buttonText: string
    position: string
    image: CmsMedia
    warning: string | null
    action: (TutorialStepActionLink | TutorialStepActionVideo | TutorialStepPlatformLink)[]
  }
}
export interface TutorialResponse {
  data: {
    id: string
    attributes: {
      position: string
      name: string
      title: string
      duration: string
      description: string
      buttonText: string
      image: CmsMedia
      tutorialType: TutorialTypes
      tutorialSteps: { data: TutorialStepResponse[] }
    }
  }
}

export interface TutorialsResponse {
  data: TutorialListItemResponse[]
}

interface TutorialListItemResponse {
  id: string
  attributes: {
    position: string
    name: string
    title: string
    duration: string
    description: string
    buttonText: string
    image: CmsMedia
    tutorialType: TutorialTypes
    platform: TutorialPlatform
    sensorKind: TutorialSensorKind
    tutorialGroup: {
      data: {
        id: string
        attributes: {
          title: string
          duration: string
          summary: string
          kind: TutorialGroups | null
        }
      } | null
    }
  }
}
